import { UPDATE_POST_SETTING, UPDATE_POST_SETTING_SUCCESS, UPDATE_POST_SETTING_ERROR, UPDATE_POST_SETTING_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdatePostSetting = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_POST_SETTING:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_POST_SETTING_SUCCESS:
      state = {
        ...state,
        data: action?.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case UPDATE_POST_SETTING_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case UPDATE_POST_SETTING_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdatePostSetting;
